export default __webpack_public_path__ + "static/media/canva.9a9205e5.png";